export default "__VITE_ASSET__Bmafv9Vy__"